var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import AsyncSelect from 'react-select/async';
import Select, { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { transparentize } from 'polished';
var LoadingIndicator = function () { return (React.createElement(FontAwesomeIcon, { icon: faSpinner, spin: true, style: { marginRight: '1rem' } })); };
var MultiValue = function (props) {
    var theme = useContext(ThemeContext);
    return (React.createElement(components.MultiValue, __assign({}, props),
        React.createElement("p", { style: {
                display: 'inline',
                color: theme.darkMode ? theme.interface5 : theme.brand_primary_color,
                marginRight: 5,
            } },
            props.data.label,
            ":"),
        ' ',
        props.data.fieldValue));
};
var reactSelectOptions = function (props) { return ({
    styles: {
        container: function (provided) { return (__assign(__assign({}, provided), { fontSize: '14px' })); },
        placeholder: function (provided) { return (__assign(__assign({}, provided), { color: props.theme.interface4 })); },
        valueContainer: function (provided) { return (__assign(__assign({}, provided), { flexWrap: 'nowrap', maxWidth: '80%', overflowX: 'hidden' })); },
        control: function (provided, state) {
            var style = __assign(__assign({}, provided), { boxShadow: '0', border: state.isFocused
                    ? "1px solid ".concat(props.theme.brand_primary_color)
                    : "1px solid ".concat(props.theme.darkMode
                        ? props.theme.interface2
                        : props.theme.interface3), transition: state.isFocused ? 'border 0.2s ease-in-out' : '', ':hover': {
                    border: state.isFocused
                        ? "1px solid ".concat(props.theme.brand_primary_color)
                        : "1px solid ".concat(props.theme.darkMode
                            ? props.theme.interface2
                            : props.theme.interface3),
                }, borderRadius: state.menuIsOpen ? ' 5px 5px 0 0' : '5px', backgroundColor: "".concat(props.theme.interface1), paddingLeft: props.isSearch ? 30 : 0, maxHeight: 42 });
            return style;
        },
        singleValue: function (provided) { return (__assign(__assign({}, provided), { color: "".concat(props.theme.darkMode ? props.theme.interface4 : props.theme.interface5) })); },
        clearIndicator: function (styles) { return (__assign(__assign({}, styles), { color: props.theme.interface5 })); },
        multiValue: function (styles) {
            return __assign(__assign({}, styles), { backgroundColor: transparentize(0.9, props.theme.darkMode
                    ? props.theme.interface5
                    : props.theme.brand_primary_color), borderRadius: '5px', padding: '4px', color: props.theme.interface5, textOverflow: 'unset !important', minWidth: 'unset', '>div': {
                    textOverflow: 'unset',
                } });
        },
        multiValueLabel: function (styles) { return (__assign(__assign({}, styles), { color: props.theme.interface5 })); },
        multiValueRemove: function (styles) { return (__assign(__assign({}, styles), { color: props.theme.interface5 })); },
        multiValueContainer: function (styles) { return (__assign(__assign({}, styles), { width: 600 })); },
        menu: function (provided) { return (__assign(__assign({}, provided), { marginTop: '-1px', borderRadius: '0 0 5px 5px', border: "1px solid ".concat(props.theme.brand_primary_color), borderTop: "1px solid ".concat(props.theme.brand_primary_color), backgroundColor: "".concat(props.theme.interface1), boxShadow: 0 })); },
        option: function (provided, state) { return (__assign(__assign({}, provided), { fontSize: '14px', ':hover': {
                backgroundColor: transparentize(0.85, props.theme.darkMode
                    ? props.theme.interface5
                    : props.theme.brand_primary_color),
            }, backgroundColor: state.isFocused
                ? transparentize(0.85, props.theme.darkMode
                    ? props.theme.interface5
                    : props.theme.brand_primary_color)
                : props.theme.interface1, color: props.theme.darkMode
                ? props.theme.interface4
                : props.theme.interface7, padding: '12px 30px' })); },
        input: function (provided) { return (__assign(__assign({}, provided), { color: props.theme.darkMode
                ? props.theme.interface4
                : props.theme.interface5 })); },
    },
    isClearable: true,
    defaultOptions: true,
    components: {
        LoadingIndicator: LoadingIndicator,
        MultiValue: MultiValue,
    },
    loadingMessage: function () { return 'Carregando...'; },
}); };
export var StyledAsyncSelect = styled(AsyncSelect).attrs(reactSelectOptions)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var StyledSelect = styled(Select).attrs(reactSelectOptions)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
